import { BeheerVos } from "@/entities/medewerkers-op-station";
import { MEDEWERKERS_OP_STATION_VOS_QUERY_KEY } from "@/entities/medewerkers-op-station/constants";
import { useApiClient } from "@/infrastructure/rest";
import { UpsertVosDto, VosBeheerDto } from "@/shared/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export function useGetBeheerVossen() {
    const apiClient = useApiClient();

    return useQuery({
        queryKey: [MEDEWERKERS_OP_STATION_VOS_QUERY_KEY],
        queryFn: async () => {
            const data = await apiClient.get<VosBeheerDto[]>(`/vossen`);
            return data?.map((vos) => BeheerVos.fromDto(vos))?.sort(BeheerVos.sort) ?? [];
        },
    });
}

type SearchVosRequest = {
    email: string;
};
export function useSearchVosByEmail() {
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async ({ email }: SearchVosRequest) => {
            const data = await apiClient.get<VosBeheerDto[]>(`/vossen/search?email=${email}`);
            return data?.map((vos) => BeheerVos.fromDto(vos)) ?? [];
        },
        onError: (error) => {
            console.error(`Fout bij het zoeken naar VOS`, error);
        },
    });
}

type UpdateVosRequest = UpsertVosDto;

export function useCreateBeheerVos() {
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async ({ entraId, inzetStationcodes }: UpdateVosRequest) => {
            await apiClient.post(`/vossen`, { entraId, inzetStationcodes });
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: [MEDEWERKERS_OP_STATION_VOS_QUERY_KEY] });
        },
        onError: (error) => {
            console.error(`Fout bij het registreren van VOS`, error);
        },
    });
}

export function useUpdateBeheerVos() {
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async ({ entraId, inzetStationcodes }: UpdateVosRequest) => {
            await apiClient.patch(`/vossen/${entraId}`, { entraId, inzetStationcodes });
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: [MEDEWERKERS_OP_STATION_VOS_QUERY_KEY] });
        },
        onError: (error) => {
            console.error(`Fout bij het updaten VOS`, error);
        },
    });
}

type DeleteVosRequest = { entraId: string };

export function useDeleteBeheerVos() {
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async ({ entraId }: DeleteVosRequest) => {
            await apiClient.delete(`/vossen/${entraId}`);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: [MEDEWERKERS_OP_STATION_VOS_QUERY_KEY] });
        },
        onError: (error) => {
            console.error(`Fout bij het verwijderen van VOS`, error);
        },
    });
}
